import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { useEligibility } from "@/contexts/EligibilityContext";
import { useQuery } from "@tanstack/react-query";
import EligibilityButton from "@/components/eligibility/EligibilityButton";

const AssessmentResults = () => {
  const { user } = useAuth();
  const { getLatestAssessment } = useEligibility();
  const navigate = useNavigate();

  const { data: assessmentResult, isLoading } = useQuery({
    queryKey: ['latestAssessment', user?.id],
    queryFn: () => getLatestAssessment(),
    enabled: !!user,
    retry: 1
  });

  if (isLoading) {
    return (
      <Card>
        <CardHeader>
          <CardTitle>Assessment Results</CardTitle>
        </CardHeader>
        <CardContent>
          <div className="animate-pulse text-muted-foreground text-center py-8">
            Loading assessment results...
          </div>
        </CardContent>
      </Card>
    );
  }

  return (
    <Card>
      <CardHeader>
        <CardTitle>Assessment Results</CardTitle>
      </CardHeader>
      <CardContent>
        {assessmentResult?.results ? (
          <div className="space-y-6">
            <div className="flex justify-between items-center">
              <div>
                <p className="text-lg font-semibold">Overall Score</p>
                <p className="text-3xl font-bold">{assessmentResult.results.overallScore}%</p>
              </div>
              <div>
                <p className="text-sm text-muted-foreground">
                  Assessment Date
                </p>
                <p className="font-medium">
                  {new Date(assessmentResult.created_at).toLocaleDateString()}
                </p>
              </div>
            </div>
            <Button 
              onClick={() => navigate("/eligibility")}
              variant="outline"
              className="w-full"
            >
              Take New Assessment
            </Button>
          </div>
        ) : (
          <div className="text-center space-y-6">
            <p className="text-muted-foreground">
              No assessment results available. Complete an eligibility assessment to see your results.
            </p>
            <EligibilityButton 
              variant="outline"
              className="w-full"
            />
          </div>
        )}
      </CardContent>
    </Card>
  );
};

export default AssessmentResults;